import { render } from "./ChildrenExtraBillingModal.vue?vue&type=template&id=1fc6a00c"
import script from "./ChildrenExtraBillingModal.vue?vue&type=script&lang=js"
export * from "./ChildrenExtraBillingModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__